import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axios";
import { societiesQueryKeys } from "../query-keys/societies.query-keys";

export type ApiKeyResponse = {
	id: number;
	name: string;
	keyPrefix: string;
	allowedRoutes: string[];
	expiresAt: string;
	isActive: boolean;
	createdAt: string;
};

const getBrokerApiKeys = async (
	brokerId: number,
): Promise<ApiKeyResponse[]> => {
	const { data } = await privateAxios.get<ApiKeyResponse[]>(
		`/societies/broker/${brokerId}/api-keys`,
	);
	return data;
};

export const useGetBrokerApiKeys = (
	brokerId: number,
	options?: { enabled?: boolean },
) =>
	useQuery({
		queryKey: societiesQueryKeys.brokerApiKeys(brokerId),
		queryFn: () => getBrokerApiKeys(brokerId),
		enabled: !!brokerId && (options?.enabled ?? true),
	});
